import { createStore } from 'vuex'
import auth from './modules/auth'
import clients from './modules/clients'
import phases from './modules/phases'
import synergist from './modules/synergist'

export default createStore({
  modules: {
    auth,
    clients,
    phases,
    synergist
  }
})
